export default __webpack_public_path__ + "static/media/copyWallet.9f8a59ed.svg";